import * as navigation from 'Navigation';

class StorageTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Inventory',
      closeable: false,
      options: false,
      preferenceKey: 'storage',
    };
  }
}

export default StorageTabState;
